const muy_pop = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_PRINCIPAL",
        "tarifa": {
            "id": "PPOSFIXEDLINEAVATEL",
            "price": 20.65,
            "name": "Funk 600 MB",
            "operator": "AVATEL",
            "segment": "PARTICULAR",
            "category": "fixed_line",
            "color": "",
            "commercial_enrichment": "",
            "description_file": "",
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": null,
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-11-24T18:11:25.122292+01:00",
            "updated_on": "2022-11-28T01:27:26.645777+01:00",
            "svas": [],
            "promotions": [
                "PROMOAVATEL",
                "PROMOAVATEL1"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    },
    {
        "tipoVenta": null,
        "tipoLinea": "LINEA_ADICIONAL_SVA",
        "tarifa": {
            "id": "MAS_CLICTV_10AVATEL",
            "price": 8.2645,
            "name": "Más CLICtv",
            "operator": "AVATEL",
            "image": "",
            "more_info": "",
            "permanence": 0,
            "segment": "PARTICULAR",
            "is_active": true,
            "created_on": "2022-11-24T17:53:14.479429+01:00",
            "updated_on": "2022-12-05T12:47:52.823685+01:00",
            "promotions": [
                "PROMOAVATEL2",
                "PROMOAVATEL6"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOAVATEL2",
                "duration": -1,
                "name": "Mas Click TV -5€",
                "duration_unit": "month",
                "amount": "5.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "AVATEL"
            }
        ]
    }
]

export default muy_pop